module.exports = __webpack_public_path__ + "img/00039.4914a63f.webp";